export var OfferStatusEnum;
(function (OfferStatusEnum) {
    OfferStatusEnum["DRAFT"] = "DRAFT";
    OfferStatusEnum["DRAFT_SHARED"] = "DRAFT_SHARED";
    OfferStatusEnum["ACTIVE"] = "ACTIVE";
    OfferStatusEnum["CLOSED"] = "CLOSED";
    OfferStatusEnum["CANCELED"] = "CANCELED";
})(OfferStatusEnum || (OfferStatusEnum = {}));
export const RemoteOptionsArray = ['remote', 'hybrid', 'face-to-face'];
//# sourceMappingURL=offers.interface.js.map